export default [
  { value: 'Released', label: 'Released' },
  { value: 'Announced', label: 'Announced' },
  { value: 'Continuing', label: 'Continuing' },
  { value: 'Upcoming', label: 'Upcoming' },
  { value: 'Ended', label: 'Ended' }
];
